import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';


import Layout from 'components/common/Layout';
import PatientCreateToolbar from 'components/patient/PatientCreateToolbar';
import PatientProfile from 'components/patient/PatientProfile';

import { appTitle, titleSeparator } from 'config/helmetSettings';

class OrderCreatePatientCreate extends Component {
  constructor(props) {
    super(props);

    this.onCreate = this.onCreate.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onCreate(value) {
    const { history } = this.props;
    history.push(`/charts/${value}`);
  }

  onCancel() {
    const { history } = this.props;
    history.goBack();
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>
            {appTitle} {titleSeparator} Create Order {titleSeparator} Create Patient
          </title>
        </Helmet>
        <PatientCreateToolbar
          title="Create order: Create Patient"
          href="/workflow/order/create/patient-assign"
        />
        <PatientProfile
          variant="create"
          onCreate={this.onCreate}
          onCancel={this.onCancel}
        />
      </Layout>
    );
  }
}

OrderCreatePatientCreate.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default OrderCreatePatientCreate;



// WEBPACK FOOTER //
// ./src/pages/workflow/OrderCreatePatientCreate.js